<div class="slider-container">
  <div class="slider-label">
    {{ label }}
    @if (tooltipText && tooltipText.length) {
      <fa-icon
        class="info"
        [icon]="faInfoCircle"
        [andorTooltip]="tooltipText"
        [tooltipPosition]="tooltipDirection"></fa-icon>
    }
  </div>
  <div class="content">
    @if (value !== undefined) {
      <div class="slider-value-container">
        <div class="slider-value {{ colorMode }}" [style.width.%]="value"></div>
      </div>
    }
    <ng-content></ng-content>
  </div>
</div>
